import { DepositPageMethodApi } from 'api-typings/common/common';
import { _transformCurrency } from '../currencies';
import { _transformDepositFee } from '../deposit-fees';
import { UserDepositMethod } from './user-deposit-methods.model';

export function transformUserDepositMethod(
  userDepositMethod: DepositPageMethodApi,
  userId: number,
): UserDepositMethod {
  return {
    id: userDepositMethod.id,
    name: userDepositMethod.name,
    defaultCurrency: _transformCurrency(userDepositMethod.default_currency),
    depositFees: userDepositMethod.deposit_fee_configs.map(config =>
      _transformDepositFee(config),
    ),
    nativeCharge: userDepositMethod.native_charge,
    renderingPriority: userDepositMethod.rendering_priority,
    instantPayment: userDepositMethod.instant_payment,
    userId,
  };
}
